import { formatIsoDateToDisplay } from '../../../utils/formatters'
import { getStatusColor } from '../statusTone'
import { OrderAggregatedStatus } from '../types'

interface OrderStatusCellProps {
  status?: OrderAggregatedStatus | null
}

export default function OrderStatusCell({ status }: OrderStatusCellProps) {
  if (!status?.translated_name) {
    return <span className="text-xs text-gray-400">—</span>
  }

  return (
    <div className="flex flex-col gap-0.5">
      <span className="flex items-center gap-2 text-sm text-black">
        <span
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: getStatusColor(status.status) }}
        />
        {status.translated_name}
      </span>

      {status.date && <span className="pl-4 text-xs text-gray-500">em {formatIsoDateToDisplay(status.date)}</span>}

      {status.is_partial && (
        <span className="pl-4 text-xs text-gray-500">
          {status.packages_delivered} de {status.packages_total} entregues
        </span>
      )}
    </div>
  )
}
